import { StaticPageNotFoundPage } from '@/app/pages/static-pages';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

export function StaticRoute() {
  return (
    <Routes>
      <Route path="*" element={<StaticPageNotFoundPage />} />
    </Routes>
  );
}
